<template>
    <BaseForm>
        <template #fields>
            <MultiLinkGroup>
                <MultiLink
                    :label="$t('subevents-local')"
                    :links="values.subeventsLocal"
                    :error-messages="errors.subeventsLocal"
                    @input="setFieldValue('subeventsLocal', $event)"
                    @delete="setFieldValue('subeventsLocal', $event)"
                />
                <MultiLink
                    :label="$t('subevents-other-locations')"
                    :links="values.subeventsOtherLocations"
                    :error-messages="errors.subeventsOtherLocations"
                    @input="setFieldValue('subeventsOtherLocations', $event)"
                    @delete="setFieldValue('subeventsOtherLocations', $event)"
                />
            </MultiLinkGroup>
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import { useMultiLink } from '@/components/MultiLink/composables/useMultiLink';
import MultiLink from '@/components/MultiLink/MultiLink.vue';
import MultiLinkGroup from '@/components/MultiLink/MultiLinkGroup.vue';
import { useEventInjection } from '@/event/composables/useEventInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventSubEventsSchema } from '../schemas';

const { event, createEventMultiLink } = useEventInjection();
const { getFormFieldLinks, saveMultiLinkFields } = useMultiLink(createEventMultiLink);

const subeventsLocalId = computed(() => event.value?.subeventsLocal?.id);
const subeventsOtherLocationsId = computed(() => event.value?.subeventsOtherLocations?.id);

const subeventsLocalLinks = computed(() => event.value?.subeventsLocal?.links.nodes ?? []);
const subeventsOtherLocationsLinks = computed(() => event.value?.subeventsOtherLocations?.links.nodes ?? []);

const { errors, values, setFieldValue, validate, onDiscard, resetForm } = useForm(
    EventSubEventsSchema,
    computed(() => ({
        subeventsLocal: getFormFieldLinks(subeventsLocalLinks),
        subeventsOtherLocations: getFormFieldLinks(subeventsOtherLocationsLinks),
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await saveMultiLinkFields([
            { id: subeventsLocalId.value, fieldName: 'subeventsLocal', links: values.value.subeventsLocal },
            {
                id: subeventsOtherLocationsId.value,
                fieldName: 'subeventsOtherLocations',
                links: values.value.subeventsOtherLocations,
            },
        ]);
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
